module.exports = __webpack_public_path__ + "static/homepage2-ef869c3efcaf3b6f23380d231385d978.jpg";